export default __webpack_public_path__ + "static/media/quesBankIcon.3890b9ae.svg";